import type { DepositLookupResponse } from '@massilia/queries'

import { useNavigate } from '@tanstack/react-router'
import { useState } from 'react'

import { DepositBookingInfo } from './deposit-booking-info'
import { DepositLookupForm } from './deposit-lookup-form'

interface BookingState {
  booking: DepositLookupResponse
  credentials: { dossierNumber: string; email: string; lastName: string }
}

interface DepositPaymentPageProps {
  initialValues?: {
    dossierNumber?: string
    email?: string
    lastName?: string
  }
}

export function DepositPaymentPage({ initialValues }: DepositPaymentPageProps) {
  const [bookingState, setBookingState] = useState<BookingState | null>(null)
  const navigate = useNavigate()

  if (bookingState) {
    return (
      <DepositBookingInfo
        booking={bookingState.booking}
        credentials={bookingState.credentials}
        onBack={async () => {
          await navigate({ to: '/payer-acompte' })
          setBookingState(null)
        }}
      />
    )
  }

  return (
    <DepositLookupForm
      initialValues={initialValues}
      onBookingFound={(booking, credentials) => setBookingState({ booking, credentials })}
    />
  )
}
